import { AImageProps } from '../../atoms/AImage/AImage.types';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';

export enum MAccordionControlType {
  Icon = 'Icon',
  Image = 'Image',
}

export interface MAccordionControlProps extends React.HTMLAttributes<HTMLButtonElement> {
  type?: MAccordionControlType;
  aImage?: Partial<AImageProps>;
  aIcon?: Partial<AIconProps>;
  aBody?: Partial<ABodyProps>;
  aSubheader?: Partial<ASubheaderProps>;
  icon?: string;
}
